// @flow

import { createActions } from 'redux-actions';
import { MACHETE_NS } from './constants';

export const INIT = `${MACHETE_NS}/VIEWER/INIT`;
export const READY = `${MACHETE_NS}/VIEWER/READY`;

export const RESIZE = `${MACHETE_NS}/VIEWER/RESIZE`;
export const UPDATE_META = `${MACHETE_NS}/VIEWER/UPDATE_META`;

export const TEARDOWN = `${MACHETE_NS}/VIEWER/TEARDOWN`;

// ctrl.viewer.controls.noRotate = true;
// ctrl.viewer.controls.noZoom = true;
// ctrl.viewer.controls.noPan = true;

export const SET_CONTROLS = `${MACHETE_NS}/VIEWER/SET_CONTROLS`;

const actions = createActions({
  [INIT]: ({ container, opts }) => ({ container, opts }),
  [READY]: () => null,
  [RESIZE]: () => null,
  [UPDATE_META]: (meta) => ({ meta }),
  [TEARDOWN]: () => null,
  [SET_CONTROLS]: (controlsOpts) => controlsOpts,
});

export default actions.machete.viewer;
